import { defineRoutes } from '#utils';

export const routes = defineRoutes({
  communities: {
    get: (id: string) => `/communities/${id}`,
  },
});
